import { useState } from 'react'

import { makeTraceDetails } from 'common'
import { useScreenFinishLoadTac } from 'common/hooks/useScreenFinishLoadTac'
import { useAppContext } from 'contexts/app-context/hooks'
import { isEmpty } from 'lodash'
import { Routes } from 'common/constants'

function useYourPersonalData() {
  const { privacyCenterContent, isAppLoading, isAppError, isAppActive, userSelectedEntity } =
    useAppContext()

  const [isHystoryButtonHidden] = useState(false)

  const content = privacyCenterContent?.components?.yourPersonalData?.content

  const isActive = privacyCenterContent?.components?.yourPersonalData?.isActive

  const isErrorOrInactive = isAppError || isEmpty(content) || !isActive || !isAppActive

  const traceDetails = makeTraceDetails(!!isActive, content)

  useScreenFinishLoadTac({
    name: 'YourPersonalData',
    screen: Routes.YOUR_PERSONAL_DATA,
    action: 'YourPersonalDataFinishLoad',
    entity: userSelectedEntity,
    shouldSend: !isAppLoading && !isErrorOrInactive,
    logLabel: 'send your personal data finish tac',
  })

  const title = content?.title ?? ''
  const subtitle = content?.subtitle ?? ''
  const description = content?.description ?? ''
  const reportHistoryButton = content?.reportHistoryButton ?? ''
  const reportCards = content?.reportCards ?? []

  const descriptionList = description.split('\n')

  return {
    title,
    subtitle,
    description,
    descriptionList,
    reportHistoryButton,
    reportCards,
    isErrorOrInactive,
    traceDetails,
    isHystoryButtonHidden,
    isAppLoading,
  }
}

export { useYourPersonalData }
